import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-grid-system';
import styled from 'styled-components';
import { ButtonWithDropDownMenu, NormalCheckBoxField, NormalFormSelectionField, NormalFormTextField } from '../molecules';
import { useUserLanguage } from '@/customHooks';
import textsData from '@/textData/CreatePropertyTexts.json'
import { CreateUnitData, LanguageType } from '@/custom-types';
import { BedSizeOption } from '@/graphql/generated';
import { bedSizeMapper } from '@/helpers';

type DropDownMenuActionsProps = {
  edit: (id: number) => void
  delete: (id: number) => void
}

type CreateUnitSimpleFormProps = {
  onAction: (data: CreateUnitData) => void
  id: number
  dropDownMenuActions: DropDownMenuActionsProps
}

const emptyData: CreateUnitData = {
  name: '',
  bedSize: BedSizeOption.Twin,
  privateBath: false,
  airConditioner: false,
  fan: false,
  id: 0,
}

const CircledNumber = styled.div`
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary1};
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  border-style: solid;
  border-width: 1px;
  border-radius: 50px;
  border-color: ${({ theme }) => theme.colors.primary1};
`;

const Wrapper = styled(Container)`
  background-color: ${({ theme }) => theme.colors.light};
  border-radius: ${({ theme }) => theme.border.radius.lg};
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  padding-top: 0.5rem;
`
const bedSizes = (userLanguage: LanguageType) => {
  return [
    BedSizeOption.Twin,
    BedSizeOption.TwinXl,
    BedSizeOption.Double,
    BedSizeOption.Queen,
    BedSizeOption.King,
  ].map((bedSize) => ({
    name: bedSizeMapper(bedSize, userLanguage),
    value: bedSize,
  }))
}

export const CreateUnitSimpleForm = ({ onAction, id, dropDownMenuActions }: CreateUnitSimpleFormProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.createUnitsForm : textsData.en.createUnitsForm

  const [state, setState] = useState(emptyData)

  const dropDownMenuOptions = [
    {
      item: texts.dropdownMenuOptions[1],
      action: () => dropDownMenuActions.delete(id)
    }
  ]

  useEffect(() => {
    onAction(state)
    console.log(state)
  }, [state])

  return (
    <Wrapper>
      <Row align='center' justify='between'>
        <Col xs="content">
          <CircledNumber>
            <span>{id + 1}</span>
          </CircledNumber>
        </Col>
        <Col md={3}>
          <NormalFormTextField
            name="name"
            label={texts.unitName.label}
            placeholder={texts.unitName.placeholder}
            action={(value) => setState((prev) => ({ ...prev, name: value}))}
          />
        </Col>
        <Col md={3}>
          <NormalFormSelectionField<BedSizeOption>
            name="bedSize"
            label={texts.bedSize}
            options={bedSizes(userLanguage)}
            onChange={(value) => setState((prev) => ({ ...prev, bedSize: value }))}
            value={BedSizeOption.Twin}
          />
        </Col>
        {/* <Col md={2}>
          <NormalFormNumberField
            name="beds"
            label={texts.beds.label}
            placeholder={texts.beds.label}
            action={(value) => setState((prev) => ({ ...prev, beds: parseInt(value)}))}
          />
        </Col> */}
        <Col md={1}>
          <NormalCheckBoxField
            name="privateBath"
            label={texts.bath}
            onChange={(value) => setState((prev) => ({ ...prev, privateBath: value }))}
          />
        </Col>
        <Col md={1}>
          <NormalCheckBoxField
            name="airConditioner"
            label={texts.airConditioner}
            onChange={(value) => setState((prev) => ({ ...prev, airConditioner: value }))}
          />
        </Col>
        <Col md={1}>
          <NormalCheckBoxField
            name="fan"
            label={texts.fan}
            onChange={(value) => setState((prev) => ({ ...prev, fan: value }))}
          />
        </Col>
        {/* <Col md={2}>
          <NormalFormNumberField
            name="baths"
            label={texts.baths.label}
            placeholder={texts.baths.label}
            action={(value) => setState((prev) => ({ ...prev, baths: parseInt(value)}))}
          />
        </Col> */}
        {/* <Col>
          <NormalFormNumberField
            name="size"
            label={texts.size.label}
            onChange={(value) => setState((prev) => ({ ...prev, size: parseInt(value ?? '0')}))}
          />
        </Col> */}
        <Col xs="content">
          <ButtonWithDropDownMenu
            options={dropDownMenuOptions}
            position='left'
          />
        </Col>
      </Row>
    </Wrapper>
  )
}